import { useSelector } from 'react-redux';
import { RemoteRecord } from '@client/common/redux/RemoteRecord';
import { selectNewsroomNews } from '@client/content/redux/newsroom/redux';
import { NewsroomNewsType } from 'b2b-common/core/content/Newsroom.types';

export function useNewsroomNewsData(): RemoteRecord<NewsroomNewsType> {
  return useSelector(selectNewsroomNews);
}
